<template>
  <section class="section section-shaped section-lg min-h-screen flex items-center justify-center">
        <div class="max-w-screen-sm md:w-1/3">
          <div class="card shadow-sm rounded-3xl mx-4" v-if="!postSenEmail">

            <div class="flex flex-row-reverse">
              <router-link to="/auth/login" class="go-back">
                  <Close class="text-white"/>
              </router-link>
              <div class="logo"></div>
            </div>

            <div class="card-body px-lg-5 pt-lg-5">
              <p class="mx-auto my-4">
                Si has olvidado tu contraseña, podemos enviarte un correo a la
                dirección con la que creaste tu cuenta en Salud E-LEARNING para
                reestablecerla
              </p>
              <form @submit.prevent="sendEmail">
                <CustomInput
                  identity="email"
                  ref="email"
                  label="Correo electrónico"
                  placeholder="Correo electrónico"
                  v-model="email"
                  :rules="{
                    required: true,
                    email: true,
                  }"
                />

                <div class="text-center">
                  <span v-if="!loginButton">
                    <button type="submit" class="btn-recover my-4">
                      RESTABLECER CONTRASEÑA
                    </button>
                  </span>
                  <span v-else>
                    <button
                      class="btn btn-recover my-4"
                      style="width: 95px"
                      disabled
                    >
                      <div class="row">
                        &nbsp;&nbsp;
                        <half-circle-spinner
                          :animation-duration="600"
                          :size="17"
                          color="#ffffff"
                          style="margin-left: 25%;padding-top: 2px;"
                        />&nbsp;
                      </div>
                    </button>
                  </span>
                </div>
              </form>
            </div>
          </div>
          <div class="card shadow-sm rounded-3xl mx-4" v-else>
            
            <div class="card-body px-lg-5">
              <p class="mx-auto my-4">
                Rebice su bandeja de entrada para continuar el cambio de contraseña
              </p>
            </div>
          </div>
        </div>
  </section>
</template>
<script>
import toastr from "toastr";
import axios from "axios";
import { HalfCircleSpinner } from "epic-spinners";
import Close from "../../../v2/src/components/icons/Close.vue";
import CustomInput from "../../../v2/src/components/CustomInput.vue";

export default {
  name: "ResetPassword",
  components: {
    HalfCircleSpinner,
    CustomInput,
    Close
  },
  data() {
    return {
      email: null,
      url: process.env.VUE_APP_LOCAL_URL,
      loginButton: false,
      postSenEmail: false,
    };
  },
  created() {},
  methods: {
    sendEmail: function() {
      var url_tk = "/oauth/token";
      axios
        .post(url_tk, {
          grant_type: "client_credentials",
          client_secret: process.env.VUE_APP_CLIENT_AP,
         client_id: process.env.VUE_APP_CLIENT_ID
        })
        .then((response) => {
          var url = "/api/v1/resetPassword";
          var token = (axios.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.access_token);

          this.loginButton = true;
          axios
            .post(url, {
              headers: {
                token,
              },
              email: this.email,
              url: this.url,
              proyect_id: process.env.VUE_APP_PROYECT_ID
            })
            .then((response) => {
              if (response.data === 403) {
                toastr.error("email no registrado!");
                this.loginButton = false;
              } else {
                this.postSenEmail = true;
                toastr.success("Email enviado!");
                this.loginButton = false;
              }
            })
            .catch(() => {
              this.loginButton = false;
              toastr.error(
                "un error a ocurrido intente nuevamente o contacte a soporte@cambiandotusalud.com!"
              );
            });
        });
    },
  },
};
</script>

<style scoped>
section {
  background-image: url(/image/resource/11_fondo_png.jpg);
  background-size: cover;
  background-position: center;
}

.go-back {
  position: relative;
  color: #fff;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(180deg, #f1946d 0%, #ea560e 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 5px 6px #00000029;
}
.go-back> svg{
    margin-top: 7px;
    margin-left: 7px;
}

button {
  outline: none !important;
}

.input-group {
  border-radius: 0 !important;
}

.logo {
  width: 110px;
  height: 38px;
  background-size: contain;
  background-image: url(/image/brand/logo.png);
  margin: 0 auto;
  margin-top: 14px;
  background-repeat: no-repeat;
}

.btn-recover {
  background: transparent linear-gradient(180deg, #f1946d 0%, #ea560e 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  opacity: 1;
  color: #ffffff;
  font-size: 16px;
  width: 80%;
  height: 52px;
  max-width: 284px;
  margin: 0 auto;
}

.input-group-alternative {
  box-shadow: none !important;
  border: 0.5px solid #a7a7a7;
}

.input-group-prepend {
  margin-right: 0 !important;
}
</style>
